export default {
  watch: {
    // isLoading(newValue) {
    //   if (!newValue && this.$route.hash) {
    //     this.handleHashAfterDataLoad();
    //   }
    // }
  },
  methods: {
    handleHashAfterDataLoad() {
      if (this.$route.hash) {
        this.$nextTick(() => {
          this.scrollToHash();
        });
      }
    },
    scrollToHash() {
      const hash = this.$route.hash;
      if (hash) {
        const id = hash.substring(1);

        const element = document.getElementById(id);
        if (!element) {
          return;
        }

        if (this.openCollapsibleItem && this.openCollapsibleItem(id)) {
          this.$nextTick(() => {
            setTimeout(() => {
              const updatedElement = document.getElementById(id);
              if (updatedElement) {
                this.performScroll(updatedElement);
              }
            }, 400);
          });
        } else {
          this.performScroll(element);
        }
      }
    },
    performScroll(element) {
      if (!element) {
        return;
      }

      const elementTop = element.getBoundingClientRect().top + window.pageYOffset;
      const offset = 100;

      window.scrollTo({
        top: elementTop - offset,
        behavior: "smooth"
      });

      let lastScrollTop = document.documentElement.scrollTop;

      const checkScrollEnd = () => {
        const scrollTop = document.documentElement.scrollTop;
        if (scrollTop === lastScrollTop) {
          element.classList.add("animate-border");
          setTimeout(() => {
            element.classList.remove("animate-border");
            history.replaceState(null, null, " ");
          }, 2900);
        } else {
          lastScrollTop = scrollTop;
          requestAnimationFrame(checkScrollEnd);
        }
      };

      requestAnimationFrame(checkScrollEnd);
    }
  }
};
